import Groups from "@/pages/Groups";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/groups")({
  component: RouteComponent,
  params: {
    parse: raw => ({agencyId: +raw.agencyId}),
    stringify: params => ({agencyId: params.agencyId?.toString()}),
  },
  loader: () => {
    getDefaultStore().set(selectedCompanyIdAtom, null);
  },
});

function RouteComponent() {
  const {agencyId} = Route.useParams();
  return <Groups agencyId={agencyId} />;
}
